export default defineNuxtPlugin({
  name: 'csp-theme',
  enforce: 'pre',
  setup(nuxtApp) {
    const nonce = import.meta.server
      ? useRequestEvent()?.context.cspStyleNonce
      : document.querySelector<HTMLMetaElement>('meta[name="csp-style-nonce"]')
          ?.nonce
    nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
      if (nonce && vuetifyOptions.theme !== false) {
        vuetifyOptions.theme = { ...vuetifyOptions.theme, cspNonce: nonce }
      }
    })
  },
})
